import { memo } from 'react'

import s from './TestingButtons.module.scss'
import { useSwiper } from 'swiper/react'
import classNames from 'classnames'

interface IButtonsProps {
    onClick?: any
    lightTheme?: boolean
}

export const PreviousButtonTest = memo(({ onClick, lightTheme }: IButtonsProps) => {
    const swiper = useSwiper()
    return (
        <button
            className={classNames(s.button, s.prev, lightTheme ? s.lightArrowBtn : '')}
            onClick={
                onClick
                    ? () => {
                          onClick()
                          swiper?.slidePrev()
                      }
                    : () => swiper?.slidePrev()
            }
        >
            <img
                src='/assets/svg/testArrow.svg'
                alt=''
                className={s.testArrow}
            />
        </button>
    )
})

export const NextButtonTest = memo(({ onClick, lightTheme }: IButtonsProps) => {
    const swiper = useSwiper()
    return (
        <button
            className={classNames(s.button, s.next, lightTheme ? s.lightArrowBtn : '')}
            onClick={
                onClick
                    ? () => {
                          onClick()
                          swiper?.slideNext()
                      }
                    : () => swiper?.slideNext()
            }
        >
            <img
                src='/assets/svg/testArrow.svg'
                alt=''
                className={classNames(s.testArrow, s.testArrowNext)}
            />
        </button>
    )
})
